import './App.css';
import DigibonMain from './overview/DigibonMain';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { useState, useRef, useEffect } from 'react';
import Config from './Config'



function App() {
  const [text, setText] = useState("init");
  const [tenantId, setTenantId] = useState(Config.GetEntraTenantId());
  const [clientId, setClientId] = useState(Config.GetEntraClientId());
  

  const toggleText = () => {
    setText((prevText) => (prevText === "init" ? "loaded" : "init"));
  };

  if (text==="init") {
    Config.load().then(p => { 
      
      setTenantId(Config.GetEntraTenantId());
      setClientId(Config.GetEntraClientId());
      toggleText(); 
    });
    return <div >Loading...</div>
  }
  
  const authority=`https://login.microsoftonline.com/${tenantId}`;

  const msalConfig = {
    auth: {
      clientId: clientId,
      authority: authority,
      redirectUri: Config.GetEntraRedirect(), // Your redirect URI
    },
  };

  console.log("msalConfig", msalConfig);

  const msalInstance = new PublicClientApplication(msalConfig);


  return <MsalProvider instance={msalInstance}>
  <div className="App">
      <DigibonMain></DigibonMain>
  </div>
</MsalProvider>;

  
  
}


export default App;
